import React from 'react';
import { Section } from './ui/Section';
export function Transformation() {
  const rows = [{
    without: 'Improvisas cada clase',
    with: 'Syllabus de 12 semanas listo',
    category: 'Planificación'
  }, {
    without: 'Corriges por intuición',
    with: 'Método probado con soluciones',
    category: 'Técnica'
  }, {
    without: 'Alumnos que desaparecen',
    with: 'Sistema de retención de 4 fases',
    category: 'Retención'
  }, {
    without: 'Buscas música en el último momento',
    with: 'Listas organizadas listas para usar',
    category: 'Música'
  }, {
    without: '"La que enseña baile"',
    with: 'Instructora PRO con autoridad',
    category: 'Autoridad'
  }, {
    without: 'No sabes cuánto cobrar',
    with: 'Fórmula exacta de precio',
    category: 'Negocio'
  }];
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <Section variant="alt" data-id="element-285">
      <div className="text-center mb-8" data-id="element-286">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-4 text-brand-title" data-id="element-287">
          Del Caos a la Excelencia
        </h2>
        <p className="font-body text-lg text-brand-text max-w-3xl mx-auto mb-6" data-id="element-288">
          Lo que cambia desde la primera semana
        </p>

        <div className="bg-white border border-brand-borderAccent rounded-2xl p-6 max-w-2xl mx-auto mb-8 shadow-card" data-id="element-289">
          <div className="text-5xl mb-3" data-id="element-290">⏰</div>
          <h3 className="font-display text-2xl font-bold text-brand-title mb-2" data-id="element-291">
            180+ Horas/Año
          </h3>
          <p className="font-body text-brand-text leading-relaxed" data-id="element-292">
            Recupera entre 3 y 5 horas semanales que ahora pierdes planificando
            manualmente.
          </p>
        </div>
      </div>

      <h3 className="font-display text-2xl font-bold text-center mb-6 text-brand-title" data-id="element-293">
        TABLA DE TRANSFORMACIÓN
      </h3>

      <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-294">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto mb-8" data-id="element-295">
        <table className="w-full min-w-[700px] border-collapse bg-white rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-296">
          <thead data-id="element-297">
            <tr className="bg-brand-bgAlt border-b border-brand-border" data-id="element-298">
              <th className="text-left p-3 text-brand-textMuted font-heading font-semibold w-1/3 tracking-wide uppercase text-sm" data-id="element-299">
                ❌ Sin el Manual
              </th>
              <th className="text-left p-3 text-brand-title font-display font-bold w-1/3 tracking-wide uppercase text-sm" data-id="element-300">
                ✅ Con el Manual PRO
              </th>
            </tr>
          </thead>
          <tbody data-id="element-301">
            {rows.map((row, i) => <tr key={i} className="hover:bg-brand-bgAlt transition-colors border-b border-brand-border last:border-0" data-id="element-302">
                <td className="p-3" data-id="element-303">
                  <div className="font-heading font-bold text-brand-subtitle text-sm mb-2" data-id="element-304">
                    {row.category}
                  </div>
                  <div className="font-body text-brand-text text-sm" data-id="element-305">
                    {row.without}
                  </div>
                </td>
                <td className="p-3" data-id="element-306">
                  <div className="font-body text-brand-subtitle font-semibold text-sm" data-id="element-307">
                    {row.with}
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="text-center" data-id="element-308">
        <button onClick={scrollToPricing} className="bg-gradient-red hover:opacity-90 text-white font-bold text-xl md:text-2xl py-4 px-10 rounded-btn transition-opacity w-full md:w-auto tracking-wide shadow-red-glow-lg" data-id="element-309">
          🚀QUIERO ENSEÑAR MEJOR →
        </button>
      </div>
    </Section>;
}